/* unplugin-vue-components disabled */import { render } from "./AuthorImg.vue?vue&type=template&id=21596417"
import script from "./AuthorImg.vue?vue&type=script&lang=js"
export * from "./AuthorImg.vue?vue&type=script&lang=js"

import "./AuthorImg.vue?vue&type=style&index=0&id=21596417&lang=less"
script.render = render

export default script